import { render, staticRenderFns } from "./ManageCriteriaModal.vue?vue&type=template&id=0cd0f334&scoped=true&"
import script from "./ManageCriteriaModal.vue?vue&type=script&lang=js&"
export * from "./ManageCriteriaModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageCriteriaModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ManageCriteriaModal.vue?vue&type=style&index=1&id=0cd0f334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0f334",
  null
  
)

export default component.exports